<script lang="ts">
    import { Link } from "svelte-routing";
    import { ROUTES } from "./routes"
</script>

<p>
    <Link to={ROUTES.HOME}>&lt;&lt;&nbsp;back to home page</Link>
</p>

<h5 class="text-h5">Page not found</h5>
